import { useContext } from 'react';
import invariant from 'invariant';
import MuiFieldsContext from '../MuiFieldsContext';
export default function useMuiFieldsContext() {
  var ctx = useContext(MuiFieldsContext);
  invariant(ctx, "Use 'useMuiFieldsContext' inside <MuiFieldsProvider>");
  return ctx;
}